import type { ReactNode } from 'react';
import { cx } from './cx';

/** Пустой список набора — `.k-empty` в kit.css (родной `ScrEmptyView`, Э4.11): значок 44,
 *  слово 15 и подстрока 13 столбиком по центру. `big` — пустой РАЗДЕЛ героем (кадр iOS
 *  R01-broadcasts: значок 80, заголовок 24, подводка 17) с действием `action` под ним
 *  (широкая акцентная капсула) — одно пустое состояние на кабинет. */
export function KEmpty({
  icon,
  title,
  note,
  className,
  big,
  action,
}: {
  icon?: ReactNode;
  title: ReactNode;
  note?: ReactNode;
  className?: string;
  big?: boolean;
  action?: ReactNode;
}) {
  return (
    <div className={cx('k-empty', big && 'k-empty--big', className)}>
      {icon != null ? (
        <span className="k-empty__ico" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className="k-empty__t">{title}</p>
      {note != null && note !== '' ? <p className="k-empty__n">{note}</p> : null}
      {action ? <div className="k-empty__act">{action}</div> : null}
    </div>
  );
}
